export default __webpack_public_path__ + "static/media/14t.9725b8c6.jpg";